export default {
  mounted() {
    this.grids.map(grid => {
      const target = this.$refs[grid.code][0].$el.querySelector('div.card-wrap div');
      target.setAttribute('style', 'padding: 0px !important; margin: 0px !important;');
    });
  },
};
